export const agentMarginDetailsReducer = (state = { loading: false }, action) => {
  switch (action.type) {

    case "GET_AGENT_MARGIN_DETAILS_LIST_REQUEST":
      return { ...state, loading: true, agentMarginDetailsList: null };

    case "GET_AGENT_MARGIN_DETAILS_LIST_SUCCESS":
      return { ...state, loading: false, agentMarginDetailsList: action.payload };

    case "GET_AGENT_MARGIN_DETAILS_LIST_FAILED":
      return { ...state, loading: false, agentMarginDetailsList: null, error: action.payload };

    case "GET_AGENT_MARGIN_DETAILS_REQUEST":
      return { ...state, loading: true, agentMarginDetails: null };

    case "GET_AGENT_MARGIN_DETAILS_SUCCESS":
      return { ...state, loading: false, agentMarginDetails: action.payload };

    case "GET_AGENT_MARGIN_DETAILS_FAILED":
      return { ...state, loading: false, agentMarginDetails: null, error: action.payload };

    case "ADD_AGENT_MARGIN_DETAILS_REQUEST":
      return { ...state, loading: true };

    case "ADD_AGENT_MARGIN_DETAILS_SUCCESS":
      return { ...state, loading: false, lastAddedAgentMarginDetails: action.payload.data };

    case "ADD_AGENT_MARGIN_DETAILS_FAILED":
      return { ...state, loading: false, error: action.payload };

    case "UPDATE_AGENT_MARGIN_DETAILS_REQUEST":
      return { ...state, loading: true };

    case "UPDATE_AGENT_MARGIN_DETAILS_SUCCESS":
      return { ...state, loading: false, agentMarginDetails: action.payload };

    case "UPDATE_AGENT_MARGIN_DETAILS_FAILED":
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};